import type { ImportedDocumentEvidencePayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A field of a generated document founded on an imported document, `type: 'imported_document'`
 * discriminant. `name` is the text frozen at generation time — never re-read from the live document.
 */
class ImportedDocumentEvidenceView {
	readonly type: 'imported_document';
	readonly importedDocumentId: number;
	readonly name: string;

	constructor(payload: ImportedDocumentEvidencePayload) {
		this.type = 'imported_document';
		this.importedDocumentId = payload.importedDocument.id;
		this.name = payload.name;

		Object.freeze(this);
	}
}

export default ImportedDocumentEvidenceView;
